__turbopack_context__.v({
  "card": "joJMJq_card",
  "container": "joJMJq_container",
  "content": "joJMJq_content",
  "image": "joJMJq_image",
});
